import React from 'react';
import { CommonWordsManager } from './CommonWordsManager';

interface MemoManagementProps {
  isOpen: boolean;
  onClose: () => void;
}

const MemoManagement: React.FC<MemoManagementProps> = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <CommonWordsManager
      onWordSelect={() => {}}
      onClose={onClose}
    />
  );
};

export default MemoManagement;
